import { render, staticRenderFns } from "./ribbon.vue?vue&type=template&id=4e6675ae&scoped=true"
import script from "./ribbon.component.ts?vue&type=script&lang=ts&external"
export * from "./ribbon.component.ts?vue&type=script&lang=ts&external"
import style0 from "./ribbon.vue?vue&type=style&index=0&id=4e6675ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6675ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e6675ae')) {
      api.createRecord('4e6675ae', component.options)
    } else {
      api.reload('4e6675ae', component.options)
    }
    module.hot.accept("./ribbon.vue?vue&type=template&id=4e6675ae&scoped=true", function () {
      api.rerender('4e6675ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/ribbon/ribbon.vue"
export default component.exports